export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const waitingForApprovalIcon = require("../assets/waiting_approval.svg");
export const darkPlusIcon = require("../assets/dark_plus_icon.svg");
export const bluePlusIcon = require("../assets/blue_plus_icon.svg");
export const calenderIcon = require("../assets/calender_icon.png");
export const filterIcon = require("../assets/filter_icon.png");
export const plusIcon = require("../assets/blue_plus_icon.svg");